
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { BookOpen, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface HelpAlertProps {
  showHelp: boolean;
  setShowHelp: (show: boolean) => void;
}

export function HelpAlert({ showHelp, setShowHelp }: HelpAlertProps) {
  if (!showHelp) return null;
  
  return (
    <Alert variant="default" className="bg-blue-50 border-blue-200 text-blue-800">
      <div className="flex items-start">
        <Info className="h-4 w-4 mt-1" />
        <div className="ml-2">
          <AlertTitle className="text-blue-800">Administrator Guide</AlertTitle>
          <AlertDescription className="text-blue-700">
            <p className="mb-2">
              This section allows you to manage certificate retention policies, execute archival processes, 
              and view archived records. Different states have different regulatory requirements for how long records
              must be maintained.
            </p>
            <div className="flex items-center gap-2 mt-3">
              <Button 
                variant="outline" 
                size="sm" 
                className="h-8 bg-white border-blue-300 hover:bg-blue-50"
                onClick={() => setShowHelp(false)}
              >
                Dismiss
              </Button>
              <Button 
                variant="link" 
                size="sm" 
                className="h-8 text-blue-700 gap-1 hover:text-blue-900"
              >
                <BookOpen className="h-3 w-3" />
                Open detailed guide
              </Button>
            </div>
          </AlertDescription>
        </div>
      </div>
    </Alert>
  );
}
